import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequest } from "../apiService/allApi";
import Swal from "sweetalert2";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 LOGIN API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const requestData = {
      email: email,
      password: password,
    };

    try {
      const response = await apiRequest(
        "api/customer/login",
        "POST",
        requestData
      );

      if (response?.data) {
        // Store token
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("profiledata", JSON.stringify(response?.data));
        // console.log(response);
        Swal.fire({
          icon: "success",
          text: response?.data?.message,
          text:'Login Succesfully',

        });

        navigate("/");
window.location.reload()
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: e.response?.data?.message || "Login failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-4">
          <div className="auth-box">
            <h2>Login</h2>
            <hr />

            <div className="text-center authbox-1">
              <h6>Welcome Back</h6>
              <p>Enter your Email Id and password to proceed</p>
            </div>

            <form onSubmit={handleSubmit}>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <div className="d-flex justify-content-center">
                <button
                  className="common_blackButton__CWUUs"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>
            </form>

            <div className="auth-link">
              <Link to="/forgot-password">Forgot Password?</Link>
              <br />
              <Link to="/signup"> Sign up</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
